import React from "react";
import Header from "../_components/Header";
import Footer from "../_components/Footer";
import ImageHero from "./image1.jpg";
import "./VideosPage.css";
import { FormattedMessage } from "react-intl";
import Media from "react-media";
import HeaderMobile from "../_components/HeaderMobile";

import * as Tabs from "@radix-ui/react-tabs";
import Button from "../_components/Button";
const VideosPage = () => {
  return (
    <div className="Media">
      <Media query={{ minWidth: 768 }}>
        {(matches) => (matches ? <Header /> : <HeaderMobile />)}
      </Media>
      <section
        className="Media-hero"
        style={{
          height: "150px",
          width: "100%",
        }}
      ></section>
      <div className="row">
        <div className="col-12">
          <h4 className="categorias-title">Vídeos</h4>
        </div>
      </div>
      <section className="m-5">
        <Tabs.Root defaultValue="2025" orientation="vertical">
          <Tabs.List className="tab-header-list" aria-label="tabs photos">
            <Tabs.Trigger className="tab-header-item" value="2019">
              2019
            </Tabs.Trigger>
            <Tabs.Trigger className="tab-header-item" value="2022">
              2022
            </Tabs.Trigger>
          <Tabs.Trigger className="tab-header-item" value="2023">
              2023
            </Tabs.Trigger>
            <Tabs.Trigger className="tab-header-item" value="2024">
              2024
            </Tabs.Trigger>
            <Tabs.Trigger className="tab-header-item" value="2025">
              2025
            </Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content className="tab-content-wrapper" value="2019">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/RqHFT19p0X8"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/yodRPwbs5ns"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/ZpAYgmaxhdg"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/KE8M7xO3ksQ"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/Fu4nwkUMlHY"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
          </Tabs.Content>
          <Tabs.Content className="tab-content-wrapper" value="2022">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/LaJ5thkGUuM"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/b3fDn4ywmcY"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
          </Tabs.Content>
            <Tabs.Content className="tab-content-wrapper" value="2023">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/jdUrz5MSIto?si=70htvOKGhjYJxbgh"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/J9mN5H2-ayw?si=pT_JJPzJx7tFCVMZ"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
          </Tabs.Content>
          <Tabs.Content className="tab-content-wrapper" value="2024">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/34uFs_XAJrY?si=eP960xj3NaoKcyzb"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/n64nR0Hc-QA?si=-Fo2DrOKlHxDu_g1"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
          </Tabs.Content>
          <Tabs.Content className="tab-content-wrapper" value="2025">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/g5YrfCLs1uo?si=FBQnyHEqyXP-ELDa"
                frameborder="0"
                allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </div>
          </Tabs.Content>
        </Tabs.Root>
      </section>
      <Footer />
      <Media query={{ minWidth: 768 }}>
        {(matches) =>
          matches ? (
            ""
          ) : (
            <section className="inscription-fixed-bar">
              <Button
                className="inscription-fixed"
                href="https://sportmaniacs.com/es/services/inscription/costa-atlantica-mtb-2025-22958"
                target="_blank"
                rel="noopener noreferrer"
              >
                Inscríbete
              </Button>
            </section>
          )
        }
      </Media>
    </div>
  );
};

export default VideosPage;
